<template>
  <div>
    <search-comp :search-show="true" @onSearch="onSearch" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div v-if="!isRoomCondition" class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Ca</div>
                <el-select v-model="searchParams.shift_id" placeholder="">
                  <el-option
                    v-for="item in shiftOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div v-if="!isRoomCondition" class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Ngày</div>
                <CalendarSelect
                  v-model="searchParams.date"
                  style="display: block"
                  mode="date"
                />
                <!-- <SingleCalendar
                  v-model="searchParams.date"
                  @input="onChangeSearchDate"
                /> -->
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Khách sạn</div>
                <el-select
                  v-model="searchParams.hotel_ids"
                  multiple
                  collapse-tags
                  placeholder=""
                >
                  <el-option
                    v-for="item in allHotelOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
                <!-- <div class="flex center-center">
                  <input v-model="searchParams.room_start" type="text" />
                  <div class="ltr-arrow"></div>
                  <input v-model="searchParams.room_end" type="text" />
                </div> -->
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Sai lệch</div>
                <el-select
                  v-model="searchParams.diff"
                  multiple
                  collapse-tags
                  placeholder=""
                >
                  <el-option label="Sleep" value="Sleep"></el-option>
                  <el-option label="Skip" value="Skip"></el-option>
                  <el-option label="People" value="People"></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div v-if="!isRoomCondition" class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Trạng thái đặt phòng</div>
                <el-select
                  v-model="searchParams.booking_status"
                  multiple
                  collapse-tags
                  placeholder=""
                >
                  <el-option label="Đang ở" value="1"></el-option>
                  <el-option label="Đã trả phòng" value="2"></el-option>
                  <el-option label="Đã đến" value="3"></el-option>
                  <el-option label="Sẽ đến" value="4"></el-option>
                  <el-option label="Sẽ đi" value="5"></el-option>
                  <el-option
                    label="Phòng liên tục xếp khách"
                    value="6"
                  ></el-option>
                  <el-option label="Chưa có đặt phòng" value="7"></el-option>
                </el-select>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Hạng</div>
                <el-select v-model="searchParams.room_level" placeholder="">
                  <el-option label="Chọn" :value="null"></el-option>
                  <el-option
                    v-for="item in allRoomLevelOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
                <!-- <div class="child-w-80">
                  <select>
                    <option :value="null">Chọn</option>
                    <option v-for="item in allRoomLevelOptions" :key="item.id">
                      {{ item.name }}
                    </option>
                  </select>
                </div> -->
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Tình hình phân công</div>
                <el-select v-model="searchParams.assign" placeholder="">
                  <el-option label="Chọn" :value="null"></el-option>
                  <el-option label="Đã phân công" :value="1"></el-option>
                  <el-option label="Chưa phân công" :value="0"></el-option>
                </el-select>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Trạng thái</div>
                <el-select
                  v-model="searchParams.room_status"
                  multiple
                  collapse-tags
                  placeholder=""
                >
                  <el-option label="VD" value="01"></el-option>
                  <el-option label="VC" value="02"></el-option>
                  <el-option label="VCI" value="04"></el-option>
                  <el-option label="OOO" value="05"></el-option>
                  <el-option label="OOS" value="06"></el-option>
                  <el-option label="OD" value="11"></el-option>
                  <el-option label="OC" value="12"></el-option>
                  <el-option label="OCI" value="14"></el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
  </div>
</template>

<script>
import { getAllRoomLevelApi } from '@/api/Room/roomLevel'
import { getListShiftApi } from '@/api/configuration/hotel/shift.js'
import { getAllHotel } from '@/api/hotel.js'
export default {
  props: {
    isRoomCondition: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchParams: {
        // room_start: null,
        // room_end: null,
        hotel_ids: [],
        room_level: null,
        room_status: [],
        booking_status: [],
        shift_id: null,
        assign: null,
        diff: [],
        drif: null,
        date: this.$moment(new Date()).format('YYYY-MM-DD')
      },
      allHotelOptions: [],
      shiftOptions: [],
      allRoomLevelOptions: []
    }
  },
  async mounted() {
    // Get room level options
    const data = await getAllRoomLevelApi()
    this.allRoomLevelOptions = data.data
    // Get shift options
    const data1 = await getListShiftApi()
    this.shiftOptions = data1.data || []
    if (this.shiftOptions.length > 0) {
      this.searchParams.shift_id = this.shiftOptions[0].id
    }
    // Get hotel options
    const data2 = await getAllHotel()
    this.allHotelOptions = data2.data
    this.onSearch()
    // Check room-condition prop
    if (this.isRoomCondition) {
      this.searchParams = {
        hotel_ids: [],
        diff: [],
        drif: null
      }
    }
  },
  methods: {
    onSearch() {
      this.$emit('onSearch', this.searchParams)
    },
    onReset() {
      if (this.isRoomCondition) {
        this.searchParams = {
          hotel_ids: [],
          diff: [],
          drif: null
        }
      } else {
        this.searchParams = {
          // room_start: null,
          // room_end: null,
          hotel_ids: [],
          room_level: null,
          room_status: [],
          booking_status: [],
          shift_id: this.shiftOptions[0]?.id ?? null,
          assign: null,
          diff: [],
          drif: null,
          date: this.$moment(new Date()).format('YYYY-MM-DD')
        }
      }

      this.$emit('onReset', this.searchParams)
    }
  }
}
</script>
